(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zc-emoji-ticker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const initTicker = (root) => {
      if (!root || root.dataset.zcEmojiReady === "1") return;
      const marquee = root.querySelector("[data-zc-emoji-marquee]");
      const seed = marquee && marquee.querySelector("[data-zc-emoji-loop]");
      if (!marquee || !seed || reduceMotion) return;

      root.dataset.zcEmojiReady = "1";
      let lastWidth = 0;

      const buildLoop = () => {
        if (root.offsetWidth === 0) return;
        if (root.offsetWidth === lastWidth && marquee.classList.contains("is-ready")) return;
        lastWidth = root.offsetWidth;

        marquee.querySelectorAll("[data-zc-emoji-loop]").forEach((el, i) => {
          if (i > 0) el.remove();
        });

        const minWidth = root.offsetWidth * 2 + Math.max(seed.offsetWidth, 1);
        let guard = 0;
        while (marquee.scrollWidth < minWidth && guard < 16) {
          const clone = seed.cloneNode(true);
          clone.setAttribute("aria-hidden", "true");
          marquee.appendChild(clone);
          guard += 1;
        }

        const loopPx = seed.offsetWidth;
        if (loopPx < 8) return;

        const speed = Math.max(1, Number(root.dataset.speed) || 5);
        const pxPerSec = 28 + speed * 10;
        marquee.style.setProperty("--zc-emoji-loop", loopPx + "px");
        marquee.style.setProperty("--zc-emoji-tape-s", Math.max(8, loopPx / pxPerSec) + "s");
        marquee.classList.add("is-ready");
        marquee.style.animation = "none";
        void marquee.offsetWidth;
        marquee.style.animation = "";
      };

      const observer = new ResizeObserver(buildLoop);
      observer.observe(root);
      buildLoop();
    };

    document.querySelectorAll("[data-zc-emoji-ticker]").forEach(initTicker);

    document.addEventListener("shopify:section:load", (event) => {
      const root = event.target.querySelector("[data-zc-emoji-ticker]");
      if (root) initTicker(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
